
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type autoSyncVisualizationDialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function autoSyncVisualizationDialogRT(): TemplateResult<autoSyncVisualizationDialogRTRootProps> {
    return _createElement('div', { 'className': 'dialog-container' }, _createElement('div', {
        'className': 'close',
        'onClick': this.close
    }, _createElement('svg', {
        'width': '13',
        'height': '13',
        'viewBox': '0 0 13 13',
        'fill': 'none',
        'xmlns': 'http://www.w3.org/2000/svg'
    }, _createElement('path', {
        'fillRule': 'evenodd',
        'clipRule': 'evenodd',
        'd': 'M11.9226 0.744078C12.248 1.06951 12.248 1.59715 11.9226 1.92259L1.92259 11.9226C1.59715 12.248 1.06951 12.248 0.744078 11.9226C0.418641 11.5972 0.418641 11.0695 0.744078 10.7441L10.7441 0.744078C11.0695 0.418641 11.5972 0.418641 11.9226 0.744078Z',
        'fill': '#FF0000'
    }), _createElement('path', {
        'fillRule': 'evenodd',
        'clipRule': 'evenodd',
        'd': 'M0.744078 0.744078C1.06951 0.418641 1.59715 0.418641 1.92259 0.744078L11.9226 10.7441C12.248 11.0695 12.248 11.5972 11.9226 11.9226C11.5972 12.248 11.0695 12.248 10.7441 11.9226L0.744078 1.92259C0.418641 1.59715 0.418641 1.06951 0.744078 0.744078Z',
        'fill': '#FF0000'
    }), _createElement('path', {
        'fillRule': 'evenodd',
        'clipRule': 'evenodd',
        'd': 'M11.9226 0.744078C12.248 1.06951 12.248 1.59715 11.9226 1.92259L1.92259 11.9226C1.59715 12.248 1.06951 12.248 0.744078 11.9226C0.418641 11.5972 0.418641 11.0695 0.744078 10.7441L10.7441 0.744078C11.0695 0.418641 11.5972 0.418641 11.9226 0.744078Z',
        'stroke': '#FF0000',
        'strokeLinecap': 'round',
        'strokeLinejoin': 'round'
    }), _createElement('path', {
        'fillRule': 'evenodd',
        'clipRule': 'evenodd',
        'd': 'M0.744078 0.744078C1.06951 0.418641 1.59715 0.418641 1.92259 0.744078L11.9226 10.7441C12.248 11.0695 12.248 11.5972 11.9226 11.9226C11.5972 12.248 11.0695 12.248 10.7441 11.9226L0.744078 1.92259C0.418641 1.59715 0.418641 1.06951 0.744078 0.744078Z',
        'stroke': '#FF0000',
        'strokeLinecap': 'round',
        'strokeLinejoin': 'round'
    }))), _createElement('div', { 'className': 'dialog-content' }, [_createElement('div', {
            'className': 'cm_vehicle-visualization-container',
            'key': '15730'
        }, this.visualization)], this.isVehicleError ? _createElement('div', {
        'className': 'cm_vehicle-error',
        'key': '1682'
    }, _translate(`autosync_visualizer_vehicle_error`)) : null, this.isVisualizationError ? _createElement('div', {
        'className': 'cm_visualization-error',
        'key': '1801'
    }, '\n      ', _translate(`autosync_visualizer_part_error`), '\n    ') : null));
}
        export const componentNames = []